import { countryList } from './countryList';
export const regulatoryList = [
  {
    id: 1,
    fields: [
      {
        name: 'unique_identifier_number',
        translationKey: 'unique_identifier_number',
        dataType: 'text',
        required: true,
      },
      {
        name: 'document_number',
        translationKey: 'document_number',
        dataType: 'text',
        required: true,
      },
      {
        name: 'identification_document_country',
        translationKey: 'identification_document_country',
        dataType: 'dropdown',
        dataValues: countryList,
        required: true,
      },
      {
        name: 'identification_document_type',
        translationKey: 'identification_document_type',
        dataType: 'dropdown',
        dataValues: [
          {
            translationKey: 'id_card',
            value: 'ID card',
          },
          {
            translationKey: 'passport',
            value: 'Passport',
          },
        ],
        required: true,
      },
    ],
    triggers: [
      {
        type: 'payment',
        value: 2000,
      },
      {
        type: 'payout',
        value: 2000,
      },
      {
        type: 'cancel',
        value: 2000,
      },
    ],
  },
];
